import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import {
  AccountCircle,
  Settings as SettingsIcon,
  Logout,
} from "@mui/icons-material";
import { SPACING } from "../../theme/constants";

export default function UserProfileMenu({ anchorEl, onClose, onLogout }) {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    onClose();
    navigate(path);
  };

  const handleLogout = () => {
    onClose();
    onLogout();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={Boolean(anchorEl)}
      onClose={onClose}
      onClick={onClose}
      PaperProps={{
        elevation: 3,
        sx: {
          width: 220,
          mt: SPACING.sm,
        },
      }}
    >
      <MenuItem onClick={() => handleNavigation("/dashboard/profile")}>
        <ListItemIcon>
          <AccountCircle fontSize="small" />
        </ListItemIcon>
        Profile
      </MenuItem>
      <MenuItem onClick={() => handleNavigation("/dashboard/settings")}>
        <ListItemIcon>
          <SettingsIcon fontSize="small" />
        </ListItemIcon>
        Settings
      </MenuItem>
      {/* <MenuItem
        onClick={() => window.open("https://docs.example.com", "_blank")}
      >
        <ListItemIcon>
          <Help fontSize="small" />
        </ListItemIcon>
        Help & Docs
      </MenuItem> */}
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
}
